<template>
    <v-action
        tag="form"
        trigger="submit"
        :route="action"
        :data="getData"
        @processing="processing = $event"
        @success="_onSuccess"
        @error="_onError"
        novalidate
        v-bind="$props"
        v-on="$listeners"
    >
        <slot v-bind="this"></slot>
    </v-action>
</template>

<script>
    import hasInputs from '../mixins/has-inputs';
    import _startsWith from 'lodash/startsWith';
    export default {
        name: 'VForm',
        mixins: [
            hasInputs,
        ],
        props: {
            action: {
                type: String,
                required: true,
            },
            method: {
                type: String,
                default: 'post',
                validator: value => {
                    return ['get', 'post', 'put', 'patch', 'delete'].indexOf(value) !== -1;
                }
            },
            config: {
                type: Object,
            },
            reset: {
                type: Boolean,
            },
        },
        data() {
            return {
                processing: false,
                feedback: {},
            };
        },
        watch: {
            processing(value) {
                this.$emit("processing", value);
            },
        },
        methods: {
            _onSuccess(response) {
                this.resetData();
                this.$emit('success', response);
            },
            _onError(error) {
                if (error.response && error.response.data) {
                    this.feedback = error.response.data['errors'] || {};
                }
                this.$emit('error', error);
            },
            getData() {
                // TODO: Заменить $data на getData в input, кроме того добавить зависимость от вычисляемого свойства excludedData, в случаях, когда в $data, все же приходиться записать что-то промежуточное
                return this.inputs.reduce((data, input) => {
                    return objectToFormData(input.isNative || input.isIgnored ? {} : input.$data, { indices: true }, data, input.name);
                }, new FormData(this.$el));
            },
            resetData() {
                if (this.reset) {
                    this.$el.reset();
                    this.$emit('reset');
                }
            },
            getFeedback(prefix) {
                let feedback = [];

                Object.keys(this.feedback).forEach(key => {
                    if (_startsWith(key, prefix)) feedback.push(this.feedback[key]);
                });

                return feedback;
            },
            clearFeedback(prefix) {
                Object.keys(this.feedback).forEach(key => {
                    if (_startsWith(key, prefix)) this.feedback[key] = undefined;
                });
            },
        },
        provide() {
            return {
                $form: this,
            };
        },
    }
</script>